import Cookies from 'js-cookie';
import { isEmpty } from 'lodash';

import apiGet from '@api/api-get';
import apiPost from '@api/api-post';
import apiDelete from '@api/api-delete';
import apiPut from '@api/api-put';

interface IResult {
  code: number,
  msg: string,
  result: any,
}

const dashboardService = {

  // 获取可移动数据
  getModelList: async () => {
    const parmes = {
      access_token: Cookies.get('access_token'),
    };
    const data: IResult | null =
      await apiGet('/mg/users/user_config/dashboard', parmes);
    if (!data) return [];
    return (data as IResult).result;
  },

  // 修改可移动数据
  editModelList: async (parmes: any) => {
    const token = Cookies.get('access_token');
    const data: IResult | null =
      await apiPut(`/mg/users/user_config/dashboard?access_token=${token}`, parmes);
    if (!data) return [];
    return (data as IResult).result;
  },

  // 获取人效数据
  getEffectList: async () => {
    const data: IResult | null =
      await apiGet('/mg/human_efficiency/dashboard');
    if (!data) return [];
    return (data as IResult).result;
  },

  // 获取人力指标
  getPowerList: async () => {
    const data: IResult | null =
      await apiGet('/mg/hr_indicator/dashboard');
    if (!data) return [];
    return (data as IResult).result;
  },

  // 获取人才需求
  getTalentList: async () => {
    const data: IResult | null =
      await apiGet('/mg/hr_indicator/recruitment/dashboard');
    if (!data) return [];
    return (data as IResult).result;
  },

  // 获取招聘动态数据
  getRivalList: async () => {
    const data: IResult | null =
      await apiGet('/mg/rival/recruit/dashboard');
    if (!data) return [];
    return (data as IResult).result;
  },

  // 猜你喜欢
  jobAttention: async (recent: string) => {
    const data: IResult | null =
      await apiGet(`/mg/hr_indicator/attention_jobs?recent=${recent}`);
    if (!data) return [];
    return (data as IResult).result;
  },

  // 我的收藏
  jobCollected: async (recent: string) => {
    const data: IResult | null =
      await apiGet(`/mg/hr_indicator/collected_jobs?recent=${recent}`);
    if (!data) return [];
    return (data as IResult).result;
  },

  // 我的收藏
  jobHot: async (recent: string) => {
    const data: IResult | null =
      await apiGet(`/mg/hr_indicator/hot_jobs?recent=${recent}`);
    if (!data) return [];
    return (data as IResult).result;
  },

  // 历史查看职位
  jobHistory: async (recent: string) => {
    const data: IResult | null =
      await apiGet(`/mg/hr_indicator/history_jobs?recent=${recent}`);
    if (!data) return [];
    return (data as IResult).result;
  },

  // 收藏/取消收藏 职位
  jobCollection: async (params: any) => {
    const data: IResult | null =
      await apiPost('/mg/market/job_collection', params);
    if (!data) return null;
    return data;
  },

  // 消费查询次数
  consumerQuery: async (params: any) => {
    const data: IResult | null = await apiPost(`/mg/market/consume_chances?access_token=${params.access_token}`, { count: params.count });
    if (!data) return [];
    return (data as IResult);
  },

  // 公司搜索
  searchCompany: async (companyName: string) => {
    const res: any = await apiGet(`/mg/rival/company/search?keyword=${companyName}`);
    if (res.code !== 0 || isEmpty(res)) return [];
    return res.result;
  },

  // 反馈建议
  sugusessName :async (parmes: any) => {
    const res: any = await apiPost('/mg/market/feedback', parmes);
    if (res.code !== 0 || isEmpty(res)) return [];
    return res.result;
  },
};


export default dashboardService;
